import React from "react";
import { Footer, Navbar } from "../components";

const ComoComprarPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-5 py-4">
        <h1 className="text-center" data-aos="fade-up">Como comprar</h1>
        <hr />
        <ol className="mt-4" data-aos="fade-up" data-aos-delay="120">
          <li>Elige el curso o paquete que necesitas.</li>
          <li>Agrega al carrito y revisa tu pedido.</li>
          <li>Finaliza por WhatsApp o desde el carrito.</li>
          <li>Recibes acceso inmediato y el material correspondiente.</li>
        </ol>
        <p className="mt-3">
          Si necesitas un paquete personalizado, escribenos por WhatsApp y te
          armamos una propuesta.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default ComoComprarPage;
